const SAFE_FLOORS = new Set([30, 60, 90]);

const creature = (type, name, behavior) => ({type, name, behavior});

const CREATURES = {
  reefFish: creature('fish', '淺瀨旬魚', '沿桶壁光帶巡游，追逐季節浮游物'),
  aji: creature('fish', '銀背鯵群', '以密集隊形追隨水流轉向'),
  salmon: creature('salmon', '逆流鮭群', '循著微弱心跳逆流而上'),
  yellowtail: creature('tuna', '疾游鰤', '高速切入魚群，再突然潛入深處'),
  mackerel: creature('mackerel', '青銀鯖群', '沿鹽度交界形成高速銀色隊列'),
  sardine: creature('school', '星幕鰯群', '受驚時聚成閃動的銀色魚幕'),
  tai: creature('fish', '旬光鯛', '在光影交界緩游並啄食沉屑'),
  bonito: creature('tuna', '洄游鰹', '跟隨季節急流穿越相鄰樓層'),
  flyingFish: creature('flying-fish', '水刃飛魚', '躍離水面，以胸鰭切過疾風'),
  eel: creature('eel', '桶隙穴子', '藏在木縫與沉積物下等待獵物'),
  squid: creature('squid', '墨隱烏賊', '放出墨雲後從另一方向接近'),
  octopus: creature('octopus', '擬木蛸', '模仿木紋與漆面伏在桶壁'),
  crab: creature('crab', '鏽甲蟹', '搬運碎屑築巢並守住底層通道'),
  urchin: creature('urchin', '深棘海膽', '聚集於沉積地帶形成不可觸群落'),
  jellyfish: creature('jellyfish', '磷光海月', '隨壓力潮汐收縮並釋放藍色微光'),
  shell: creature('shell', '潮音古貝', '埋於沉積物，以開闔聲回應潮汐'),
  angler: creature('angler', '幽燈鮟鱇', '用提燈引導獵物走入無光水域'),
  deepFish: creature('fish', '盲眼深海魚', '依靠水壓震動辨認周圍生命'),
  memoryFish: creature('spirit', '古層記憶魚', '從殘留刀法與味覺記憶中短暫顯形'),
  sardineGhost: creature('spirit', '銀鰯怨靈', '聚成魚群形狀，追問被浪費的理由'),
  chefShade: creature('spirit', '無名板前影', '重複生前最後一次未完成的刀法'),
  ancientEel: creature('eel', '古木盲鰻', '穿行腐木內部並吞食殘留記憶'),
  inkSpirit: creature('spirit', '墨潮殘靈', '藏於無光墨雲，模仿來訪者的輪廓'),
  cat: creature('cat', '貓板前', '伏在桶緣觀察，伺機偷走最肥美的魚')
};

const MYTHICAL_CREATURES = {
  91: [
    creature('spirit', '始祖鮭神・紅洄', '率領燃燒金鱗逆流，回應紅澪血脈'),
    creature('salmon', '神代金鮭', '守護始祖鮭神脫落的每一片鱗')
  ],
  92: [
    creature('spirit', '始祖玉子神・天黃', '以溫暖蛋黃之膜包覆整個樓層'),
    creature('fish', '半熟膜游靈', '在柔軟世界膜內隨步伐緩慢晃動')
  ],
  93: [
    creature('spirit', '始祖甘海老神・櫻躍', '每次躍起都令周圍時間暫時減慢'),
    creature('crab', '神代櫻甲蝦', '收集蝦神留下的粉色時間碎屑')
  ],
  94: [
    creature('spirit', '始祖烏賊神・無星墨', '以一滴神墨吞沒光線與星辰'),
    creature('squid', '宇宙墨眷', '從神墨邊緣出現並抹除自身輪廓')
  ],
  95: [
    creature('spirit', '始祖海膽神・金爆', '釋放如超新星般純粹的鮮味脈衝'),
    creature('urchin', '日輪神棘', '環繞海膽神形成旋轉金色棘環')
  ],
  96: [
    creature('spirit', '始祖鯖神・銀河主', '以神鯖群構築跨越整層的銀河'),
    creature('mackerel', '星界神鯖', '沿始祖神留下的銀色軌道永恆洄游')
  ],
  97: [
    creature('spirit', '始祖鮪神・天衡眼', '凝視來者，衡量刀法、心意與選擇'),
    creature('tuna', '御前赤身衛', '環繞神眼巡弋，不容虛妄接近')
  ],
  98: [
    creature('spirit', '始祖鯨神・百層鳴', '低唱時令一百層木桶同時產生共鳴'),
    creature('whale', '神歌幼鯨影', '循著古老歌聲穿越樓層與記憶')
  ],
  99: [
    creature('spirit', '眾旬神・萬味座', '眾神幻影共同審視抵達源頭的資格'),
    creature('spirit', '始祖板前・無名御影', '記錄來訪者在審判中做出的每次選擇'),
    creature('fish', '百旬神使', '攜帶百層氣息環繞眾神席位')
  ],
  100: [
    creature('spirit', '旬之始祖・源心', '與客人的心跳同步，孕育不可重現的旬味'),
    creature('spirit', '百年味噌心靈', '守護月球般心臟內累積的百年記憶'),
    creature('fish', '一期一會原生魚', '只在心跳完全一致的片刻現身一次')
  ]
};

const SCENE_STORIES = {
  swarm: ['撞桶銀潮', '入口追旬水道', '初學者觀測棧'],
  wind: ['朝市風廊', '叫賣聲水紋', '小肌競流帶'],
  sakura: ['櫻瓣洄游河', '春光落水口', '櫻鯛花影'],
  blades: ['飛魚躍刃場', '試刀急流', '碎水銀弧'],
  salt: ['鹽晶記憶壁', '乾海風裂隙', '鯖魚醃藏帶'],
  galaxy: ['萬鰯銀河', '晨星旋流', '群游渦臂'],
  heartbeat: ['祖鮭心室', '血脈赤潮', '逆流甦醒口'],
  moon: ['不破月鏡', '月影靜水', '夜鯛巡游環'],
  shells: ['潮聲貝床', '赤貝藏歌處', '細砂回音谷'],
  maze: ['洄游岔流', '鰹之迷途', '循環水門'],
  'broken-blades': ['學徒斷刀塚', '未完夢影', '沉底試切台'],
  shadow: ['巨鰤掠影', '慢半拍水道', '高速伏流'],
  bubbles: ['氣泡月台', '白魚列車', '升水軌道'],
  'soy-rain': ['醬油雨幕', '琥珀染水區', '鰹香匯流口'],
  'rice-fog': ['酢飯暖霧', '失向魚群', '米香低能見域'],
  cat: ['貓板前偷鮮台', '鯖魚藏匿架', '桶緣足跡'],
  classroom: ['潮汐黑板', '出刀節拍線', '等待練習池'],
  lacquer: ['剝漆呼吸壁', '百年木紋層', '真鯛暗紅水域'],
  'splash-swords': ['銀劍飛沫陣', '太刀魚躍層', '交錯水刃'],
  'buri-boss': ['鰤王裂流場', '移動一刀線', '王影迴旋域'],
  sleep: ['暖光休眠灣', '停滯午後流', '熟成魚夢床'],
  glass: ['玻璃鱗雨', '銳光漂浮帶', '銀魚折射場'],
  paper: ['問診票漂流心', '未言墨字河', '客心匯聚點'],
  chopsticks: ['斷筷墓山', '穴子木隙', '失手記錄層'],
  'vortex-boss': ['萬鯵銀龍捲', '洄游出口封鎖', '王魚渦心'],
  tears: ['學徒淚海', '鹽味擴散圈', '小肌苦澀流'],
  sunset: ['金紅夕凪', '夕鯛返游線', '無風水鏡'],
  'last-light': ['末陽沉降井', '金目追光帶', '深層入口影'],
  membrane: ['晨暗境界膜', '單向下潛口', '無光魚界線'],
  gravity: ['初重壓區', '下沉氣泡井', '彎曲桶壁'],
  snow: ['深海海雪原', '緩降白魚帶', '埋念沉積層'],
  'sleeping-tuna': ['巨鮪眠床', '鼾聲震波', '桶底低頻流'],
  lantern: ['鮟鱇孤燈', '迷途誘引路', '絕暗伏擊圈'],
  pressure: ['鮪之重壓室', '持刀試心線', '變形木桶'],
  spines: ['海膽棘林', '不可觸小徑', '紫黑核巢'],
  ink: ['烏賊墨夜', '邊界消失域', '盲行墨潮'],
  barrel: ['沉沒醬油樽', '百年滲香帶', '深褐發酵霧'],
  rust: ['鏽刀練習場', '純熟試切石', '深海白身域'],
  'whale-bones': ['鯨骨長橋', '黑水骨谷', '唯一渡淵線'],
  'fire-path': ['水中守火路', '鰻魚熱流', '火候共鳴環'],
  cages: ['沉沒蟹牢', '耐心解鎖區', '鏽鏈泥床'],
  'upside-market': ['倒懸深海市場', '逆價浮箱', '重力錯置巷'],
  'bent-chopsticks': ['水壓彎筷場', '蛸之柔力試煉', '低速夾取區'],
  'warm-tear': ['玉澄暖淚泉', '守火圓環', '溫水玉子域'],
  jellyfish: ['海月磷光搖籃', '柔性托舉流', '藍脈睡眠區'],
  altar: ['魚骨深海祭壇', '無求獻禮台', '出汁回音井'],
  'frozen-soy': ['黑醬冰原', '封味裂谷', '冰封赤身層'],
  'silent-school': ['靜止魚群壁', '萬眼注視區', '無聲水道'],
  'middle-eye': ['塔心巨眼', '上下光界', '凝視中軸'],
  'blood-tide': ['鮪血暗潮', '磷光熄滅帶', '赤色湧流口'],
  'tuna-heart': ['鮪之心室', '重拍推流脈', '心血迴圈'],
  sharpening: ['深壓研刀台', '砥石甦醒場', '鋼音水紋'],
  recipe: ['失落食譜海', '缺頁漂流帶', '古味拼合桌'],
  'tuna-boss': ['王鮪深海王座', '紅眼巡弋環', '五十米獵場'],
  'king-shell': ['王者蛻皮旗', '空王座水域', '魚皮飄帶'],
  bouquet: ['深海磷魚花束', '獻暗光庭', '群魚花莖流'],
  wreckage: ['壓壞桶墓群', '失敗者輪廓', '碎木重壓谷'],
  blackout: ['絕對無光底', '盲手探索區', '感覺取代視線'],
  'old-board': ['古俎板濕香室', '埋藏刀痕', '木香記憶層'],
  kombu: ['百年昆布森', '葉間封路', '古法入口'],
  'lost-shime': ['失傳酢締殘響', '碎味記憶池', '小肌古法台'],
  'bone-knives': ['魚骨刀陣', '生命重量試場', '古鯛骨谷'],
  'salt-fossil': ['遠古鹽化石原', '時間封存層', '古海結晶壁'],
  'withered-field': ['枯山葵田', '最後清水井', '辛香沉眠土'],
  cracks: ['漏水古桶', '記憶流失縫', '穴子裂隙巢'],
  'chef-shadow': ['初代板長影場', '永恆一刀線', '無人俎板'],
  'inverted-knives': ['逆刃自省林', '傲慢切開處', '鏡中白身域'],
  vinegar: ['赤酢深淵', '淚味甦醒霧', '鮪醃藏池'],
  'buried-menu': ['沙埋百年菜單', '消失季節層', '舊席挖掘區'],
  'scroll-fish': ['鯖紋古文書河', '刀讀文字場', '活卷軸魚群'],
  'knife-mound': ['千刀塚', '無名板前墓群', '古代白身祭地'],
  rot: ['腐木熟成室', '殘鮮藏匿層', '古木盲鰻道'],
  'ghost-school': ['銀鰯怨靈潮', '浪費問罪場', '群魂聚合區'],
  'ghost-guests': ['百年幻席', '未完用餐間', '過去客人迴廊'],
  'frozen-time': ['切割前一瞬', '凝止刀魚界', '停時水泡'],
  'soy-waterfall': ['黑醬油瀑布', '傲味沖刷壁', '古香垂直流'],
  peeling: ['漆殼剝落谷', '赤紅心木層', '貝類封漆床'],
  'ancient-heart': ['古法心臟', '失傳技脈', '沉緩記憶室'],
  'ghost-sushi': ['無主壽司漂流', '尋客長廊', '幽靈俎板'],
  nameless: ['無名古魚域', '失語水層', '不可命名之影'],
  'itamae-graves': ['板前俎板墓園', '一生一刀碑', '記憶守靈魚'],
  'inverted-torii': ['倒置鳥居', '方向放棄場', '倒懸旬味界'],
  'chef-boss': ['忘卻板長殿', '百刀問答陣', '鮮度審判席'],
  pearl: ['初代淚珠井', '不滅微光', '板長悲願池'],
  'cold-rice': ['最後酢飯席', '無客冷卻桌', '終席等待間'],
  void: ['空桶回音室', '自心放大域', '無答案之底'],
  'god-scar': ['世界初俎板', '神明第一刀痕', '始祖旬味眠床'],
  'no-mind-room': ['無味透明高湯', '萬味容器', '絕對無音域'],
  'diagnosis-room': ['百年問診桌', '發光客心票', '白砂無風庭'],
  'fire-room': ['黑鳥居守火間', '水中不滅爐', '溫炭休息地'],
  'salmon-god': ['紅色神極光', '燃鱗隕星河', '始祖鮭神域'],
  'tamago-god': ['半熟蛋黃世界', '柔暖世界膜', '始祖玉子神域'],
  'shrimp-god': ['櫻色慢時宇宙', '神蝦躍空', '時間甲殼帶'],
  'squid-god': ['無星神墨宙', '光滅邊界', '始祖烏賊神域'],
  'uni-god': ['金色超新星場', '神棘日輪', '純鮮爆心'],
  'mackerel-god': ['神鯖銀河', '永洄星軌', '始祖群游核心'],
  'tuna-eye': ['天衡巨神眼', '御前赤身環', '刀心審視域'],
  'whale-song': ['百層共鳴海', '鯨神歌骨橋', '神歌幼影流'],
  'god-gathering': ['眾旬神萬味座', '百神審判席', '源頭資格門'],
  'source-heart': ['月球味噌心臟', '百年記憶脈', '一期一會源泉']
};

const SAFE_RESOURCES = {
  30: ['發光問診票', '白砂', '百年桌木屑'],
  60: ['守火炭', '溫熱爐灰', '黑鳥居漆片'],
  90: ['透明高湯', '金色注連繩纖維', '無味水晶']
};

const PRIMARY_MATCHES = [
  [['鮭'], CREATURES.salmon],
  [['鯵', '小肌', '白魚', '細魚'], CREATURES.aji],
  [['鰤'], CREATURES.yellowtail],
  [['鮪', '赤身'], CREATURES.yellowtail],
  [['鯖'], CREATURES.mackerel],
  [['鰯', '沙丁魚'], CREATURES.sardine],
  [['鯛', '金目'], CREATURES.tai],
  [['鰹'], CREATURES.bonito],
  [['飛魚'], CREATURES.flyingFish],
  [['鰻', '穴子', '太刀魚'], CREATURES.eel],
  [['烏賊', '墨'], CREATURES.squid],
  [['蛸'], CREATURES.octopus],
  [['蟹'], CREATURES.crab],
  [['海膽', '海胆', '棘'], CREATURES.urchin],
  [['海月', '水母'], CREATURES.jellyfish],
  [['貝', '蛤蜊'], CREATURES.shell],
  [['鮟鱇'], CREATURES.angler]
];

function includesAny(source, words) {
  return words.some((word) => source.includes(word.toLowerCase()));
}

function addUnique(list, item) {
  if (!list.some((entry) => entry.name === item.name)) list.push(item);
}

function getPrimaryCreatures(floor, source) {
  const creatures = [];

  PRIMARY_MATCHES.forEach(([words, item]) => {
    if (includesAny(source, words)) addUnique(creatures, item);
  });

  if (source.includes('cat')) addUnique(creatures, CREATURES.cat);
  if (source.includes('ghost-school')) addUnique(creatures, CREATURES.sardineGhost);

  if (includesAny(source, ['chef-shadow', 'itamae-graves', 'ghost-guests'])) {
    addUnique(creatures, CREATURES.chefShade);
  }

  return creatures;
}

function getHabitatCreatures(floor, source) {
  if (floor.realm === 'Shallow') {
    if (includesAny(source, ['salt', 'shell', 'tears'])) {
      return [CREATURES.shell, CREATURES.mackerel];
    }

    if (includesAny(source, ['night', 'moon', 'sleep'])) {
      return [CREATURES.eel, CREATURES.reefFish];
    }

    return [CREATURES.reefFish, CREATURES.sardine];
  }

  if (floor.realm === 'Deep') {
    if (includesAny(source, ['ink', 'blackout', 'frozen'])) {
      return [CREATURES.squid, CREATURES.deepFish];
    }

    if (includesAny(source, ['cages', 'wreckage', 'bottom'])) {
      return [CREATURES.crab, CREATURES.eel];
    }

    if (includesAny(source, ['spines', 'altar', 'bones'])) {
      return [CREATURES.urchin, CREATURES.shell];
    }

    return [CREATURES.deepFish, CREATURES.jellyfish];
  }

  if (includesAny(source, ['rot', 'old-board', 'cracks', 'kombu'])) {
    return [CREATURES.ancientEel, CREATURES.memoryFish];
  }

  if (includesAny(source, ['ghost', 'void', 'blackout', 'heart'])) {
    return [CREATURES.memoryFish, CREATURES.inkSpirit];
  }

  return [CREATURES.memoryFish, CREATURES.ancientEel];
}

function getTargetCount(floor) {
  const seed = (floor.floor * 13 + floor.scene.length * 7) % 10;

  if (seed < 2) return 1;
  if (seed < 7) return 2;
  return 3;
}

function getCreatures(floor) {
  if (SAFE_FLOORS.has(floor.floor)) return [];
  if (floor.floor >= 91) return MYTHICAL_CREATURES[floor.floor] || [];

  const source = [
    floor.ingredient,
    floor.name_zh,
    floor.scene,
    floor.visual
  ].join(' ').toLowerCase();

  const creatures = getPrimaryCreatures(floor, source);
  const habitat = getHabitatCreatures(floor, source);
  const target = Math.max(creatures.length, getTargetCount(floor));

  habitat.forEach((item) => {
    if (creatures.length < target) addUnique(creatures, item);
  });

  if (!creatures.length) {
    addUnique(
      creatures,
      floor.realm === 'Ancient'
        ? CREATURES.memoryFish
        : floor.realm === 'Deep'
          ? CREATURES.deepFish
          : CREATURES.reefFish
    );
  }

  return creatures.slice(0, 3);
}

function getFallbackEnvironment(floor) {
  const realmAtmosphere = {
    Shallow: '晨光洄游水域',
    Deep: '深壓磷光水域',
    Ancient: '古法記憶沉層',
    Mythical: '白金血脈神域'
  };

  return [
    `${floor.name_zh}主景`,
    `${floor.ingredient}棲息域`,
    realmAtmosphere[floor.realm]
  ];
}

function getEnvironment(floor) {
  return SCENE_STORIES[floor.scene] || getFallbackEnvironment(floor);
}

export function getFloorEcology(floor) {
  const safe = SAFE_FLOORS.has(floor.floor);

  return {
    safe,
    creatures: getCreatures(floor),
    environment: getEnvironment(floor),
    resources: safe ? SAFE_RESOURCES[floor.floor] : []
  };
}